import { ACTIONS } from "./../constants"


const initialState = { 
  groups: [], 
  group: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: false,
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_GROUP : {
      return { ...state, success: false, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_GROUPS_INIT : {
      return { ...state, isFetching: true, success: false, error: null }
    }
    case ACTIONS.FETCH_GROUPS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, groups: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_GROUPS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_GROUP_INIT : {
      return { ...state, isLoading: true, error: null, success: false }
    }
    case ACTIONS.CREATE_GROUP_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_GROUP_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_GROUP_INIT : {      
      return { ...state, isLoading: true, error: null, success:false }
    }
    case ACTIONS.EDIT_GROUP_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_GROUP_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_GROUP_INIT : {
      return { ...state, isLoading: true, group: null, error: null }
    }
    case ACTIONS.FETCH_GROUP_SUCCEDED : {
      return { ...state, group: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_GROUP_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DELETE_GROUP_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DELETE_GROUP_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_GROUP_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
